import { CalciteLabel, CalciteOption } from "@esri/calcite-components-react";
import { Select } from "components/Select";
import {
  ADDLRequest,
  AliRecord,
  calculateDisabilityBitmask,
  decodeDisabilityBitmask,
  disabilityOptions,
} from "services/ALIRecord.d";

// Extracted components
export function ADDLDataSection({
  addlDataRequest,
  setAddlDataRequest,
  record,
}: {
  addlDataRequest: ADDLRequest;
  setAddlDataRequest: React.Dispatch<React.SetStateAction<ADDLRequest>>;
  record: AliRecord;
}) {
  return (
    <div>
      <Select
        label="Private Citizen*"
        value={
          typeof addlDataRequest.privateCit === "boolean"
            ? addlDataRequest.privateCit
              ? "true"
              : "false"
            : (addlDataRequest.privateCit ?? record.privateCit ?? "")
        }
        name="privateCit"
        onChange={(e) => {
          setAddlDataRequest((prev: ADDLRequest) => ({
            ...prev,
            privateCit: e.target.value === "true",
          }));
        }}
        scale="s"
        labelSize="s"
      >
        <CalciteOption key="true" value="true">
          Yes
        </CalciteOption>
        <CalciteOption key="false" value="false">
          No
        </CalciteOption>
      </Select>

      <CalciteLabel
        style={{ marginBottom: "4px", marginTop: "10px" }}
        scale="s"
      >
        Disability Codes*:
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            marginTop: "8px",
          }}
        >
          {disabilityOptions.map(({ value, label }) => (
            <CalciteLabel
              key={value}
              layout="inline"
              style={{ marginRight: "12px", cursor: "pointer" }}
              scale="s"
              onClick={() => {
                setAddlDataRequest((prev: ADDLRequest) => {
                  const currentCodes = decodeDisabilityBitmask(prev.dd || 0);
                  const numericValue = Number(value);
                  const isChecked = currentCodes.includes(numericValue);

                  const newCodes = isChecked
                    ? currentCodes.filter((code) => code !== numericValue)
                    : [...currentCodes, numericValue];

                  const newBitmask = calculateDisabilityBitmask(newCodes);
                  return { ...prev, dd: newBitmask };
                });
              }}
            >
              <input
                type="checkbox"
                checked={decodeDisabilityBitmask(
                  addlDataRequest.dd || 0,
                ).includes(Number(value))}
                style={{ marginRight: "6px" }}
              />
              {label}
            </CalciteLabel>
          ))}
        </div>
      </CalciteLabel>
    </div>
  );
}
